import { useCallback } from 'react';

import { initializeApp } from 'firebase/app';
import { getMessaging, getToken } from 'firebase/messaging';
import firebaseConfig from 'utils/config/firebase.config.json';
import { useRegisterDevice } from 'pages/private/hooks';

const app = initializeApp(firebaseConfig);
export const messaging = getMessaging(app);

export default function useFirebase() {
  const { mutate: registerDevice } = useRegisterDevice();

  const requestNotificationPermission = useCallback(async () => {
    try {
      const permission = await Notification.requestPermission();
      if (permission === 'granted') {
        const token = await getToken(messaging, {
          vapidKey: import.meta.env.VITE_APP_FIREBASE_KEY,
          serviceWorkerRegistration: await navigator.serviceWorker.ready,
        });
        registerDevice(token);
      } else {
        console.log('Notification permission not granted');
      }
    } catch (err) {
      console.error('Error getting FCM token:', err);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return { requestNotificationPermission, messaging, app };
}
